namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_opencode_session, {

		Fullsize_wrapper: {
			minHeight: 0,
			minWidth: 0,
			height: '100%',
		},

		Chat: {
			minWidth: 0,
			minHeight: 0,
			Prompt: {
				width: 'auto',
			},
			Send: {
				margin: 0,
			},
		},

	} )

}
